import React, { useContext, useMemo } from 'react';

import { Typography } from '@mui/material';

import { LayerContext } from 'state/LayerContext';
import { useGetSegmentInfoQuery } from 'state/apiSlice';
import { useAppSelector } from 'state/hooks';
import { selectSegmentId, selectTypicalMonth } from 'state/workflowSlice';

import { displayTypicalMonth } from 'features/common/datetimeUtils';
import { ChartTableSwitcher } from 'features/workflow_common/ChartTableSwitcher';
import { ChartHeaderTitle } from 'features/workflow_nrt/ChartHeader';
import { MaximizeButton } from 'features/workspace/MaximizeButton';

import styles from 'features/workspace/Workspace.module.css';

const title = 'Typical Volume';
// https://mui.com/material-ui/material-icons/

export function PlanningSegmentInfo() {
  const segmentId = useAppSelector(selectSegmentId);
  const typicalMonth = useAppSelector(selectTypicalMonth);

  // cached so no need to memoize
  const { layer } = useContext(LayerContext);
  const { currentData: segmentData } = useGetSegmentInfoQuery(
    { layerId: layer, routeIds: [segmentId] },
    { skip: !layer || !segmentId },
  );

  // momeoze streetName
  const streetName = useMemo(() => {
    const segmentProperties =
      segmentData && segmentData.segments[segmentId]?.properties;
    return segmentProperties
      ? `${segmentProperties.name} ${segmentProperties.cardinal_dir}`
      : '';
  }, [segmentData, segmentId]);

  const periodName = displayTypicalMonth(typicalMonth);

  return (
    <ChartHeaderTitle title={title} subtitle={streetName} date={periodName} />
  );
}

export function PlanningChartHeader() {
  return (
    <div className={styles.chart_header}>
      <div className={styles.chart_header_left}>
        <PlanningSegmentInfo />
      </div>

      <div className={styles.chart_header_right}>
        <ChartTableSwitcher />
        <MaximizeButton />
      </div>
    </div>
  );
}
